import { routes } from './routes';

export const routesLabels = {
  [routes.COMPANIES.LIST]: 'Clientes',
  [routes.INTEGRATIONS]: 'Integrações',
  [routes.PAYMENT_METHODS]: 'Formas de pagamentos',
  [routes.PERMISSIONS_GROUPS]: 'Grupos de permissões',
  [routes.USERS]: 'Usuários',
  [routes.DEVICES.LIST]: 'Terminais',
  [routes.JOBS.LIST]: 'Rotinas automáticas',
};
